// src/components/KhoAnh.js
import React, { useState } from "react";
import { luuTepQuanGia, addData } from "../services/api";
import { veDungLuong } from "../utils/thuNhoAnh";

// ============================================================
// 🗂️ KHO ẢNH — mỗi tháng một dòng (Đợt N5, 14/09/2026 — mockup màn ④)
// ------------------------------------------------------------
// Anh chốt:
//   câu 3 — lấy ảnh cũ về bằng nút ⬇️ Tải về, mỗi tháng một tệp .zip
//   câu 4 — nút 🗑️ Dọn CHỈ MỞ sau khi tháng đó đã tải về; bấm thì hỏi lại
//
// Nút Dọn khoá (xám) có hai lý do, và nói rõ lý do nào:
//   • tháng đó chưa tải về lần nào
//   • có ảnh mới vào tháng đó SAU lần tải — tải lại mới đủ
// Máy chủ kiểm lại y hệt (409) — nút xám ở đây chỉ là phép lịch sự.
// ============================================================
// ============================================================
// 💡 ẢNH GIỮ LÂU DÀI — Mẹo vặt (N6, MV4) · 🎉 Sân chơi (N7, SC5)
// ------------------------------------------------------------
// Mẹo vặt là thứ ĐỂ DÀNH, ảnh Sân chơi là KỶ NIỆM: giữ lâu dài, KHÔNG nhắc 3
// tháng, KHÔNG có nút Dọn. Chỉ đếm và cho tải cả bộ về cất. Máy chủ loại hai
// loại ảnh này khỏi mọi câu truy vấn của kho theo tháng — Dọn tháng không bao
// giờ chạm tới chúng (LOAI_ANH_GIU_LAU_DAI trong server.js).
// ============================================================
function AnhGiuLauDai({ tieuDe, tt, chuTrong, dangTai, dangLam, onTai }) {
  return (
    <div className="kho-anh-meo">
      <h4>{tieuDe}</h4>
      {tt === null ? (
        <p className="kho-anh-ghi">⏳ Đang tải…</p>
      ) : tt === "loi" ? (
        <p className="kho-anh-ghi sao-luu-loi">⚠️ Không tải được. Bấm F5 thử lại.</p>
      ) : tt.so_anh === 0 ? (
        <p className="kho-anh-ghi">{chuTrong}</p>
      ) : (
        <>
          <p className="kho-anh-ghi">
            {tt.so_anh} tấm · {veDungLuong(tt.so_byte)} · <strong>giữ lâu dài, không nhắc dọn</strong>
          </p>
          <button className="kho-anh-nut-tai" onClick={onTai} disabled={Boolean(dangLam)}>
            {dangLam === dangTai ? "Đang tải…" : "⬇️ Tải tất cả về"}
          </button>
        </>
      )}
    </div>
  );
}
function KhoAnh({ ds, anhMeo, anhSanChoi, onDoi, noiBao }) {
  const [dangLam, setDangLam] = useState(null); // "tai-2026-06" | "don-2026-06"

  // ⚠️ Chỉ báo máy chủ "đã tải về" khi tệp ĐÃ LƯU XONG trên máy — báo sớm là
  // mở nút Dọn cho ảnh chưa về tới máy (chuyện thật 14/09, xem api.js).
  // Anh chốt chỗ cất: D:\SaoLuu\QuanGia\Anh — lần đầu chọn, lần sau tự mở đúng.
  const tai = async (t) => {
    setDangLam(`tai-${t.thang_ma}`);
    try {
      const kq = await luuTepQuanGia({
        endpoint: `quan-tri/kho-anh/${t.thang_ma}/tai`,
        tenGoiY: `anh-quan-gia-${t.thang_ma}.zip`,
        idCho: "quan-gia-anh",
        moTa: "Ảnh Quản gia (.zip)",
        duoi: ".zip",
      });
      if (kq.ketQua !== "da-luu") {
        noiBao(`Chưa lưu ảnh tháng ${t.thang_hien} — nút Dọn vẫn khoá`);
        return;
      }
      await addData(`quan-tri/kho-anh/${t.thang_ma}/da-tai`, { moc: kq.moc });
      noiBao(`✅ Đã lưu "${kq.tenTep}" (${veDungLuong(kq.soByte)})`);
      onDoi();
    } catch (err) {
      noiBao(`⚠️ Chưa tải được ảnh tháng ${t.thang_hien}${err.chiTiet ? ` — ${err.chiTiet}` : ""}`);
    } finally {
      setDangLam(null);
    }
  };

  // Ảnh giữ lâu dài không có nút Dọn → không cần báo máy chủ "đã lưu". Cùng chỗ
  // cất với zip ảnh hoá đơn (D:\SaoLuu\QuanGia\Anh).
  const taiGiuLauDai = async (ma, endpoint, tenGoiY, tenLoai) => {
    setDangLam(ma);
    try {
      const kq = await luuTepQuanGia({ endpoint, tenGoiY, idCho: "quan-gia-anh", moTa: "Ảnh Quản gia (.zip)", duoi: ".zip" });
      if (kq.ketQua === "da-luu") noiBao(`✅ Đã lưu "${kq.tenTep}" (${veDungLuong(kq.soByte)})`);
    } catch (err) {
      noiBao(`⚠️ Chưa tải được ${tenLoai}${err.chiTiet ? ` — ${err.chiTiet}` : ""}`);
    } finally {
      setDangLam(null);
    }
  };
  const don = async (t) => {
    const dongY = window.confirm(
      `Dọn ${t.so_anh_con} tấm ảnh tháng ${t.thang_hien} khỏi VPS?\n\n` +
        `Anh đã tải về ngày ${t.tai_luc_hien}. Sau khi dọn, trong app các ảnh này ` +
        `hiện "🗂️ ảnh đã cất" — muốn xem thì mở tệp .zip đã tải về.`,
    );
    if (!dongY) return;
    setDangLam(`don-${t.thang_ma}`);
    try {
      const kq = await addData(`quan-tri/kho-anh/${t.thang_ma}/don`, {});
      noiBao(`🗑️ Đã dọn ${kq.so_anh_da_don} tấm ảnh tháng ${t.thang_hien}`);
      onDoi();
    } catch (err) {
      noiBao(`⚠️ Chưa dọn được${err.chiTiet ? ` — ${err.chiTiet}` : ""}`);
      onDoi();
    } finally {
      setDangLam(null);
    }
  };

  return (
    <div className="card" id="kho-anh">
      <h3>🗂️ Kho ảnh</h3>
      <h4 className="kho-anh-nhom">🧾 Ảnh hoá đơn — theo tháng</h4>
      {ds === null ? (
        <p className="kho-anh-ghi">⏳ Đang tải kho ảnh…</p>
      ) : ds === "loi" ? (
        <p className="kho-anh-ghi sao-luu-loi">
          ⚠️ Không tải được kho ảnh. Bấm F5 thử lại; vẫn vậy thì chụp màn hình gửi Claude.
        </p>
      ) : ds.length === 0 ? (
        <p className="kho-anh-ghi">Chưa có ảnh nào. Ảnh hoá đơn gắn ở trang 💰 Báo chi tiêu sẽ hiện ở đây theo từng tháng.</p>
      ) : (
        <>
          <div className="bang-cuon">
            <table className="kho-anh-bang">
              <thead>
                <tr><th>Tháng</th><th>Tuổi</th><th></th><th></th></tr>
              </thead>
              <tbody>
                {ds.map((t) => (
                  <tr key={t.thang_ma}>
                    <td>
                      <strong>{t.thang_hien}</strong>
                      <div className="kho-anh-ghi">
                        {t.so_anh_con > 0
                          ? `${t.so_anh_con} tấm · ${veDungLuong(t.so_byte)}`
                          : `đã dọn ${t.don_luc_hien || ""}`}
                        {t.so_anh_con > 0 && t.tai_luc_hien && (
                          <div>{t.da_tai_du ? `✅ đã tải ${t.tai_luc_hien}` : "có ảnh mới sau lần tải"}</div>
                        )}
                      </div>
                    </td>
                    <td className={t.tuoi_thang >= 3 && t.so_anh_con > 0 ? "kho-anh-cu" : ""}>
                      {t.tuoi_thang === 0 ? "mới" : `${t.tuoi_thang} tháng`}
                    </td>
                    <td>
                      {t.so_anh_con > 0 && (
                        <button
                          className="kho-anh-nut-tai"
                          onClick={() => tai(t)}
                          disabled={Boolean(dangLam)}
                        >
                          {dangLam === `tai-${t.thang_ma}` ? "Đang tải…" : t.da_tai_du ? "⬇️ Tải lại" : "⬇️ Tải về"}
                        </button>
                      )}
                    </td>
                    <td>
                      {t.so_anh_con > 0 && (
                        <button
                          className={t.duoc_don ? "kho-anh-nut-don" : "kho-anh-nut-khoa"}
                          onClick={() => don(t)}
                          disabled={!t.duoc_don || Boolean(dangLam)}
                          title={
                            t.duoc_don
                              ? "Dọn ảnh tháng này khỏi VPS"
                              : t.tai_luc_hien
                                ? "Có ảnh mới sau lần tải — tải lại trước"
                                : "Chưa tải về — tải về trước rồi mới dọn"
                          }
                        >
                          {dangLam === `don-${t.thang_ma}` ? "Đang dọn…" : "🗑️ Dọn"}
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <p className="kho-anh-ghi">
            Nút <strong>Dọn</strong> xám = tháng đó <strong>chưa tải về</strong> (hoặc có ảnh mới sau lần
            tải). Bấm Dọn luôn hỏi lại một câu.
          </p>
        </>
      )}
      <AnhGiuLauDai
        tieuDe="💡 Ảnh sổ tay mẹo vặt"
        tt={anhMeo === undefined ? null : anhMeo}
        chuTrong="Chưa có ảnh nào. Ảnh gắn vào mẹo ở trang 💡 Mẹo vặt sẽ tính ở đây."
        dangTai="tai-meo"
        dangLam={dangLam}
        onTai={() => taiGiuLauDai("tai-meo", "quan-tri/anh-meo-vat/tai", "anh-meo-vat.zip", "ảnh mẹo vặt")}
      />
      <AnhGiuLauDai
        tieuDe="🎉 Ảnh Sân chơi"
        tt={anhSanChoi === undefined ? null : anhSanChoi}
        chuTrong="Chưa có ảnh nào. Ảnh đăng lên 🎉 Sân chơi sẽ tính ở đây."
        dangTai="tai-san-choi"
        dangLam={dangLam}
        onTai={() => taiGiuLauDai("tai-san-choi", "quan-tri/anh-san-choi/tai", "anh-san-choi.zip", "ảnh Sân chơi")}
      />
    </div>
  );
}

export default KhoAnh;
